import { render, staticRenderFns } from "./eventosiniciados.vue?vue&type=template&id=339d1304"
import script from "./eventosiniciados.vue?vue&type=script&lang=js"
export * from "./eventosiniciados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports